/**
 * KIT category icon map — keeps the catalogue JSON serialisable.
 *
 * JSON stores an icon key (string). This helper resolves it to a
 * lucide-react component. Unknown keys fall back to a neutral tag
 * icon so a JSON typo can never crash the surface.
 */

import {
    Plug, Scissors, Brush, Droplet, Shield, Sparkles,
    FlaskConical, Briefcase, Wand2, Tag,
} from "lucide-react";

const ICONS = {
    plug: Plug,
    wand: Wand2,
    scissors: Scissors,
    brush: Brush,
    droplet: Droplet,
    shield: Shield,
    sparkles: Sparkles,
    flask: FlaskConical,
    briefcase: Briefcase,
};

export function resolveKitCategoryIcon(iconKey) {
    return ICONS[iconKey] || Tag;
}
